export default {
      id: "grade-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#grade-usage",
      toString: function () {
        return this.url;
      }
    }